import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import {
  betInputPlusOrMinus,
  GameResponseTypeName,
  globalTranslationKeys,
  numberOfRoundsEnum,
  numPadTypes,
} from '../../../../enums';
import { autoPlayBetStore, inputValidationStore } from '../../../../store';
import { useAmountValidation, handlePlusMinusValue } from '../../../../helpers';

export const StopRound = observer(({ t, marketName, limits, handleOpenNumPad }) => {
  const { switcher, stopCount } = autoPlayBetStore.autoPlayData[marketName];
  const winLossProps = {
    storeValue: stopCount,
    minValue: marketName === numberOfRoundsEnum ? 1 : limits.minBet,
    maxValue: marketName === numberOfRoundsEnum ? 100 : Infinity,
    incDec: marketName === numberOfRoundsEnum ? 1 : limits.minBet,
  };
  const onChangeEvent = ({ changeValue, propName }) => {
    autoPlayBetStore.setAutoplayStopCount(changeValue, propName);
  };
  const { onChange: handleChangeAmount, onNumberChange } = useAmountValidation(onChangeEvent);
  const notificationResponseType =
    marketName === numberOfRoundsEnum
      ? GameResponseTypeName.StopNumberOfRounds
      : GameResponseTypeName.StopIfLoss;
  const handleAutoPlayStopCount = (actionType) => {
    const changedOddValue = handlePlusMinusValue(actionType, winLossProps);
    autoPlayBetStore.setAutoplayStopCount(changedOddValue, marketName);
  };
  const onChange = (e) => {
    if (marketName === numberOfRoundsEnum) {
      return onNumberChange(e, marketName);
    }
    return handleChangeAmount(e, marketName);
  };
  const OnBlur = (e) => {
    inputValidationStore.setDefaultValue(
      e.target?.value.trim(),
      autoPlayBetStore.setAutoplayStopCount,
      winLossProps,
      marketName,
      notificationResponseType
    );
  };

  return (
    <div className='sec-row-inner-bl'>
      <div className='auto-bet-block'>
        <div className='auto-bet-bl-inner'>
          <div className='small-text-holder'>
            <p
              className='small-text'
              title={
                marketName === numberOfRoundsEnum
                  ? t(globalTranslationKeys.NumberOfRounds)
                  : t(globalTranslationKeys.StopIfLoss)
              }
            >
              {marketName === numberOfRoundsEnum
                ? t(globalTranslationKeys.NumberOfRounds)
                : t(globalTranslationKeys.StopIfLoss)}
            </p>
          </div>
          <div
            className={`inner-switch-body ${switcher ? 'active' : ''}`}
            onClick={() => autoPlayBetStore.switcherToggle(marketName)}
          >
            <span className='switch' />
          </div>
          <div className={`bet-inpt-box small ${switcher ? '' : 'disabled'} `}>
            <div className='bet-inpt-box-inner'>
              <div
                className={`bet-inpt-rulers ${
                  stopCount <= winLossProps.minValue ? 'disabled' : ''
                }`}
                onClick={() => handleAutoPlayStopCount(betInputPlusOrMinus.minus)}
              >
                <span className=' ui-lib-minus' />
              </div>
              <input
                className='bet-opt-inp'
                type='text'
                maxLength='9'
                inputMode='none'
                value={stopCount}
                onChange={onChange}
                onBlur={OnBlur}
                {...(isMobile()
                  ? {
                      onClick: (e) =>
                        handleOpenNumPad(
                          e,
                          numPadTypes.stopIfLossEndRounds,
                          marketName,
                          winLossProps
                        ),
                    }
                  : {})}
              />
              <div
                className={`bet-inpt-rulers ${
                  stopCount >= winLossProps.maxValue ? 'disabled' : ''
                }`}
                onClick={() => handleAutoPlayStopCount(betInputPlusOrMinus.plus)}
              >
                <span className=' ui-lib-plus' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
